export default __webpack_public_path__ + "019fd1a390dc07b89d2ef6f594411012.png";